import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { format_price, format_date } from '../../functions/functions_formatting.js';
import ForminputDropdown from '../forminput/forminput_dropdown.js';


export default class Tripstatistics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            trip_id: null,
            trips: [],
            sales: [],
            earnings_last30days: null,
            earnings_total: null,
            number_purchases_last30days: null,
            number_purchases_total: null,
            average_ratings: null
        };
    }


    componentDidMount() {
        if (this.props.trips && this.props.trips.length >= 1) {
            var trip_id = this.state.trip_id;
            if (!trip_id) {
                var trip_id = this.props.trips[0].trip_id;
            }
            this.updateData(trip_id);
        }
    }


    componentDidUpdate() {
        if (this.props.trips && this.props.trips.length >= 1) {
            var trip_id = this.state.trip_id;
            if (!trip_id) {
                var trip_id = this.props.trips[0].trip_id;
            }
            this.updateData(trip_id);
        }
    }


    updateData(trip_id) {
        if (trip_id != this.state.trip_id) {
            // Calculate data
            var earnings_last30days = 0;
            var earnings_total = 0;
            const sales = this.props.sales;
            sales.forEach((sale) => {
                if ((sale.created && new Date(sale.created) >= new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)) && sale.order.trip_id == trip_id) {
                    earnings_last30days += parseFloat(sale.amount_net);
                }
                if (sale.order.trip_id == trip_id) {
                    earnings_total += parseFloat(sale.amount_net);
                }
            });

            // Update state
            this.setState({
                trip_id: trip_id,
                trips: this.props.trips,
                sales: this.props.sales,
                earnings_total: earnings_total,
                earnings_last30days: earnings_last30days,
                number_purchases_last30days: this.props.sales.filter(x => x.created && new Date(x.created) >= new Date(Date.now() - 30 * 24 * 60 * 60 * 1000) && x.order.trip_id == trip_id).length,
                number_purchases_total: this.props.sales.filter(x => x.order.trip_id == trip_id).length,
                average_ratings: null
            });
        }
    }


    setTrip(key, trip_name) {
        var trip_id = this.props.trips.find(d => d.title == trip_name)?.trip_id;
        this.setState({
            trip_id: trip_id
        });
        this.updateData(trip_id);
    }


    render() {

        return (
            <div className="account__section">
                <div className="account__element">
                    <ForminputDropdown
                        name={"trip"}
                        label={"Select trip"}
                        list={this.state.trips.map(trip => trip.title)}
                        default_value={this.props.trips.find(d => d.trip_id == this.state.trip_id)?.title}
                        setFormValue={this.setTrip.bind(this)}
                        required={false}
                    />
                </div>

                <div className="account__element account__dashboard__panels-container">

                    <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Number of purchases (total)
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {this.state.number_purchases_total}
                        </div>
                    </div>

                    <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Earnings (total)
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {format_price(this.state.earnings_total)}
                        </div>
                    </div>

                    <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Number of trip views (total)
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {this.props.trips.find(d => d.trip_id == this.state.trip_id)?.views}
                        </div>
                    </div>

                    <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Number of purchases (last 30 days)
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {this.state.number_purchases_last30days}
                        </div>
                    </div>

                    <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Earnings (last 30 days)
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {format_price(this.state.earnings_last30days)}
                        </div>
                    </div>

                    {/* <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Number of trip views (last 30 days)
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {this.state.number_trip_views}
                        </div>
                    </div> */}

                </div>

                <Link to={"/trip/" + this.state.trip_id} className="account__element">
                    <span className="text-bold">Title: </span>
                    {this.props.trips.find(d => d.trip_id == this.state.trip_id)?.title}
                </Link>
                <div className="account__element">
                    <span className="text-bold">Created: </span>
                    {format_date(this.props.trips.find(d => d.trip_id == this.state.trip_id)?.created)}
                </div>
                <div className="account__element">
                    <span className="text-bold">Number of activities: </span>
                    {this.props.trips.find(d => d.trip_id == this.state.trip_id)?.activities_count}
                </div>
                <div className="account__element">
                    <span className="text-bold">Number of pictures: </span>
                    {this.props.trips.find(d => d.trip_id == this.state.trip_id)?.pictures_all.length}
                </div>

            </div>
        )
    }
}